import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HttpServiceService {

  constructor(private httpClient: HttpClient) { }

  private prepareUrl(url){
    return `${window['BASE_URL']}${url}`;
  }

  sendPostRequest(url, data, headers):Observable<any>{
    return this.httpClient.post(this.prepareUrl(url), data, {headers: headers, responseType: 'text'});
  }

  sendDirectPostRequest(url, data, headers):Observable<any>{
    return this.httpClient.post(url, data, {headers: headers, responseType: 'text'});
  }

  sendOutsideGetRequest(url, options?):Observable<any>{
    return this.httpClient.get(url, options);
  }
}
